import Device from '../../../../../../../../../../../constants/deviceSizes';

const detailConsumptionStyle = {
  display: 'flex',
  flexDirection: 'row'
};

export default {
  container: {
    display: 'flex',
    flex: '1 1 0px',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 0px 10px auto',
    height: 280,
    boxSizing: 'border-box',
    padding: '0px 10px 0px 30px',
    [Device.mobile]: {
      margin: 0,
      padding: 0
    }
  },
  consumptions: {
    ...detailConsumptionStyle,
    justifyContent: 'space-around',
    margin: 10,
    flexShrink: 0,
    boxSizing: 'border-box',
    padding: '0px 30px',
    width: '100%'
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0px 10px 10px'
  },
  titleProgress: {
    margin: '2px 10px 0px'
  },
  tag: {
    width: 110,
    display: 'flex',
    justifyContent: 'center'
  },
  icons: {
    ...detailConsumptionStyle,
    width: '100%',
    justifyContent: 'space-around'
  },
  positiveConsumption: {
    ...detailConsumptionStyle,
    alignItems: 'center',
    width: '100%'
  },
  congratulationText: {
    textAlign: 'left',
    whiteSpace: 'normal',
    marginLeft: 20
  },
  happyImg: {
    margin: 'auto',
    maxHeight: 70,
    minHeight: 50
  }
};
